import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container mt-4" }
const _hoisted_2 = { class: "mb-4" }

import { ref, provide } from 'vue';
    import type * as signalR from '@microsoft/signalr';
    import MailApp from './MailApp.vue';
    import ContactsApp from './ContactsApp.vue';
    import { useAuth } from '../composables/useAuth';
    import { AUTH_STATE_KEY, AUTH_METHODS_KEY } from '../composables/authKeys';

    interface Props {
        connection: signalR.HubConnection;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'IndexApp',
  props: {
    connection: {}
  },
  setup(__props: any) {

    const props = __props;

    const migrationType = ref<string>('Mail');

    const {
        sourceServerType,
        destServerType,
        sourceServer,
        destServer,
        sourceUser,
        destUser,
        sourcePassword,
        destPassword,
        sourceOAuthToken,
        destOAuthToken,
        sourceOAuthStatus,
        destOAuthStatus,
        sourceAuthStatus,
        destAuthStatus,
        sourceAuthSuccess,
        destAuthSuccess,
        sourceAuthenticating,
        destAuthenticating,
        showSourcePassword,
        showDestPassword,
        authenticateServer,
        invokeOAuth,
        resetSourceAuth,
        resetDestAuth
    } = useAuth();

    provide(AUTH_STATE_KEY, {
        sourceServerType,
        destServerType,
        sourceServer,
        destServer,
        sourceUser,
        destUser,
        sourcePassword,
        destPassword,
        sourceOAuthToken,
        destOAuthToken,
        sourceOAuthStatus,
        destOAuthStatus,
        sourceAuthStatus,
        destAuthStatus,
        sourceAuthSuccess,
        destAuthSuccess,
        sourceAuthenticating,
        destAuthenticating,
        showSourcePassword,
        showDestPassword
    });

    provide(AUTH_METHODS_KEY, {
        authenticateServer,
        invokeOAuth,
        resetSourceAuth,
        resetDestAuth
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[3] || (_cache[3] = _createElementVNode("h1", null, "BTSX Data Mover", -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[2] || (_cache[2] = _createElementVNode("label", {
          for: "migrationType",
          class: "form-label"
        }, "Choose the migration type", -1 /* CACHED */)),
        _withDirectives(_createElementVNode("select", {
          class: "form-select",
          id: "migrationType",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((migrationType).value = $event))
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("option", { value: "Mail" }, "Mail", -1 /* CACHED */),
          _createElementVNode("option", { value: "Contacts" }, "Contacts", -1 /* CACHED */)
        ]))], 512 /* NEED_PATCH */), [
          [_vModelSelect, migrationType.value]
        ])
      ])
    ]),
    (migrationType.value === 'Mail')
      ? (_openBlock(), _createBlock(MailApp, {
          key: 0,
          connection: __props.connection
        }, null, 8 /* PROPS */, ["connection"]))
      : (migrationType.value === 'Contacts')
        ? (_openBlock(), _createBlock(ContactsApp, {
            key: 1,
            connection: __props.connection
          }, null, 8 /* PROPS */, ["connection"]))
        : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})